module.exports = __webpack_public_path__ + "img/scroll-to-top.555f2574.svg";